export default {
  GET_REVIEWS: 'GET_REVIEWS',
  RESPOND_TO_REVIEW: 'RESPOND_TO_REVIEW',
  SHARE_REVIEW: 'SHARE_REVIEW',
  GET_STATS:"GET_STATS"
}
